import { useContext, useEffect } from "react";
import { AuthContext } from "@/guards/auth/auth-context";
import { useRequestState } from "@/hooks";
import {
  Personnels,
  requestPersonnels,
  selectPersonnelsStore,
  useBoundStore,
} from "@/services";
import { logger } from "@/utils";
import { userMock } from "@/pages/requests/components/users/__mock__/users-mock";
import { isMockEnabled } from "@/pages/requests/components/users/__mock__/utils";

export const usePersonnelList = ({
  agreementNumber,
  supplierId,
}: {
  agreementNumber: string;
  supplierId: string;
}) => {
  const { account } = useContext(AuthContext);

  const { setPersonnels } = useBoundStore(selectPersonnelsStore);

  const { data, error, setError, isLoading, setSuccess } =
    useRequestState<Personnels>();

  useEffect(() => {
    const controller = new AbortController();

    requestPersonnels(
      {
        email: account?.username ?? "",
        agreementNumber,
        supplierId,
      },
      { signal: controller.signal },
    )
      .then((response: Personnels) => {
        const data = isMockEnabled() ? userMock.LoaWorkers : response;

        setSuccess(data);
        setPersonnels(data);
      })
      .catch(error => {
        if (isMockEnabled()) {
          const data = userMock.LoaWorkers;

          setSuccess(data);
          setPersonnels(data);
        } else {
          setError(error.message);
        }

        logger.error(error);
      });
  }, [
    account,
    agreementNumber,
    setError,
    setPersonnels,
    setSuccess,
    supplierId,
  ]);

  return {
    isLoadingPersonnels: isLoading,
    personnels: data || [],
    error,
  };
};
